import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, Loader2 } from "lucide-react";

import { AppShell } from "@/components/app-shell/AppShell";
import { FormEditor } from "@/components/forms/FormEditor";
import { api, type ApiError } from "@/lib/api";

export const Route = createFileRoute("/forms/$formKey")({
  component: FormEditorPage,
});

function FormEditorPage() {
  const { formKey } = Route.useParams();
  const formQ = useQuery({
    queryKey: ["form", formKey],
    queryFn: () => api.getForm(formKey),
  });
  const sitesQ = useQuery({ queryKey: ["sites"], queryFn: () => api.listSites() });

  if (formQ.isLoading) {
    return (
      <AppShell title="Form editor">
        <div className="flex items-center gap-2 px-1 py-8 text-xs text-zinc-500">
          <Loader2 className="h-3.5 w-3.5 animate-spin" /> loading form…
        </div>
      </AppShell>
    );
  }
  if (formQ.isError || !formQ.data?.form) {
    return (
      <AppShell title="Form editor">
        <div className="rounded-md border border-ember/40 bg-ember/10 px-4 py-3 text-sm text-ember">
          {(formQ.error as ApiError | undefined)?.error ?? "Form not found."}
        </div>
        <Link
          to="/forms"
          className="mt-4 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-widest text-zinc-400 hover:text-zinc-100"
        >
          <ArrowLeft className="h-3 w-3" /> back to forms
        </Link>
      </AppShell>
    );
  }

  const original = formQ.data.form;

  return (
    <AppShell title={original.name}>
      <FormEditor
        mode="edit"
        initial={original}
        sites={sitesQ.data?.sites ?? []}
      />
    </AppShell>
  );
}
